import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { withClientConfig, trans } from '@spotahome/soyuz/client';

import { useCookie } from '@spotahome/ui-library';

import cityToggleConfig from '@spotahome/marketplace-common/src/config/cityToggleConfig';
import isFeatureDateToggleEnabled from '@spotahome/marketplace-common/src/utils/featureDateToggle';
import hideCancellationPoliciesShape from '@spotahome/marketplace-common/src/shapes/hideCancellationPolicies';

import GenericBanner from '../GenericBanner';
import FreeCancellationBanner from '../FreeCancellationBanner';

const COOKIE_NAME = 'reduced-booking-fees-banner-seen';
const COOKIE_VALUE = 1;
const COOKIE_DURATION_TWO_WEEKS = 60 * 60 * 24 * 14;

const SearchBanner = ({
  cityId,
  cancellationPolicies,
  moveIn,
  clientConfig: {
    featureToggle: { hideCancellationPolicies }
  }
}) => {
  const { getCookie, setCookie } = useCookie();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (!getCookie(COOKIE_NAME)) {
      setCookie(COOKIE_NAME, COOKIE_VALUE, {
        maxAge: COOKIE_DURATION_TWO_WEEKS
      });
      setShowBanner(true);
    }
  }, []);

  if (cityToggleConfig(cityId).showFeeOffer && showBanner) {
    return (
      <GenericBanner
        content={trans('fee-offer-banner.content.text')}
        color={'blue-indigo'}
      />
    );
  }
  if (!isFeatureDateToggleEnabled(hideCancellationPolicies)) {
    return (
      <FreeCancellationBanner
        moveIn={moveIn}
        cancellationPolicies={cancellationPolicies}
      />
    );
  }
  return null;
};

SearchBanner.propTypes = {
  cityId: PropTypes.string.isRequired,
  cancellationPolicies: PropTypes.shape({}),
  moveIn: PropTypes.string,
  clientConfig: PropTypes.shape({
    featureToggle: PropTypes.shape(hideCancellationPoliciesShape)
  }).isRequired
};

SearchBanner.defaultProps = {
  cancellationPolicies: {},
  moveIn: null
};

export default withClientConfig()(SearchBanner);
